<div class="qr-pin" data-cy="user-qr-pin">
  <div class="qr-pin-text">
    <span class="qr-pin-title">Persönliche QR-PIN</span>
    <span class="qr-pin-hint">
      Mit dieser PIN meldet sich der Benutzer am QR-Code eines Gebäudes an und kann dort
      Reparaturaufträge zu TGAs erstellen.
    </span>
    @if (active()) {
      <span class="qr-pin-state qr-pin-state-active" data-cy="user-qr-pin-state">
        @if (activeSince(); as since) {
          PIN aktiv seit {{ since | date: 'dd.MM.yyyy HH:mm' }}
        } @else {
          PIN aktiv
        }
      </span>
    } @else {
      <span class="qr-pin-state" data-cy="user-qr-pin-state">Keine PIN vergeben</span>
    }
  </div>

  @if (generatedPin(); as pin) {
    <wr-banner [icon]="{ icon: 'info-outline', pack: 'eva' }"
               status="info"
               data-cy="user-qr-pin-banner"
               [message]="'Neue PIN: ' + pin + ' – sie wird nur jetzt angezeigt.'"></wr-banner>
  }

  <div class="qr-pin-actions">
    @if (active()) {
      <button nbButton outline status="danger" size="small" data-cy="user-qr-pin-revoke"
              [disabled]="busy()" (click)="revoke()">
        Widerrufen
      </button>
    } @else {
      <button nbButton outline status="primary" size="small" data-cy="user-qr-pin-generate"
              [disabled]="busy()" (click)="generate()">
        PIN erzeugen
      </button>
    }
  </div>
</div>
